<template>
  <div class="article-content-container">
    <div class="row w-100" v-if="html_content">
        <div class="col-12">
          <div v-html="html_content" class="article"></div>
        </div>
      </div>
  </div>
</template>

<script>
import intl from "./intl/intl";
export default {
  name: "articleContent",
  components: {
 
  },
  props: {
    html_content: {
        type: String,
        default: '',
      },
    
  },

  created() {
  
  },
  computed: {
    
   
  },

  data: function () {
    return {
      intl: intl,
      
    };
  },
  methods: {
   
  },

  
};
</script>
